// Blanks Avenue - Global JavaScript

document.addEventListener('DOMContentLoaded', function() {
  initMobileMenu();
  initMegaMenu();
});

// Mobile Menu Toggle
function initMobileMenu() {
  const mobileToggle = document.querySelector('.header__mobile-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const menuIcon = document.querySelector('.menu-icon');
  const closeIcon = document.querySelector('.close-icon');

  if (!mobileToggle || !mobileMenu) return;

  mobileToggle.addEventListener('click', function() {
    const isOpen = mobileMenu.classList.toggle('is-open');
    mobileToggle.setAttribute('aria-expanded', isOpen);
    
    if (menuIcon && closeIcon) {
      menuIcon.style.display = isOpen ? 'none' : 'block';
      closeIcon.style.display = isOpen ? 'block' : 'none';
    }
  });
}

// Mega Menu (Desktop)
function initMegaMenu() {
  const shopTrigger = document.querySelector('.header__nav-item--shop');
  const megaMenu = document.querySelector('.mega-menu');

  if (!shopTrigger || !megaMenu) return;

  shopTrigger.addEventListener('mouseenter', function() {
    megaMenu.classList.add('is-open');
    const link = shopTrigger.querySelector('.header__nav-link');
    if (link) link.setAttribute('aria-expanded', 'true');
  });

  shopTrigger.addEventListener('mouseleave', function() {
    megaMenu.classList.remove('is-open');
    const link = shopTrigger.querySelector('.header__nav-link');
    if (link) link.setAttribute('aria-expanded', 'false');
  });

  megaMenu.addEventListener('mouseenter', function() {
    megaMenu.classList.add('is-open');
  });

  megaMenu.addEventListener('mouseleave', function() {
    megaMenu.classList.remove('is-open');
    const link = shopTrigger.querySelector('.header__nav-link');
    if (link) link.setAttribute('aria-expanded', 'false');
  });
}

// Cart Functions
class CartHandler {
  constructor() {
    this.cartCount = document.querySelectorAll('.cart-count');
  }

  async addToCart(variantId, quantity = 1) {
    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity }]
        })
      });

      const data = await response.json();
      this.updateCartCount();
      return data;
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.json');
      const cart = await response.json();
      
      this.cartCount.forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }
}

window.cart = new CartHandler();
